import cx from 'clsx';
import React, { memo } from 'react';

import { ReactComponent as ArrowIcon } from '@assets/svg/lightArrowDown.svg';

import useTranslation from '@hooks/useTranslation';

import { selectMapData, selectMapOpenLegend, useMapActions } from '../../store/useMapStore';
import MapMarkerSvg from '../MapMarkerSvg/MapMarkerSvg';
import style from './style.module.scss';

const MapLegend = () => {
  const { t } = useTranslation();
  const { setMapOpenLegend } = useMapActions();

  const { legend } = selectMapData();
  const openLegend = selectMapOpenLegend();

  if (!Object.keys(legend).length) {
    return null;
  }

  return (
    <div className={style.legendContainer}>
      <span className={style.legendTitleContainer}>
        {t('Facilities marks legend')}
        <ArrowIcon
          className={cx(style.arrowIcon, { [style.openedArrowIcon]: openLegend })}
          onClick={() => setMapOpenLegend(!openLegend)}
        />
      </span>
      {openLegend && (
        <div className={style.legendItemsContainer}>
          {Object.values(legend).map(({ name, icon, color }, index) => (
            <div key={index} className={style.legendItemContainer}>
              <MapMarkerSvg variant={icon} color={color} />
              {name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(MapLegend);
